import { observer } from 'mobx-react-lite'
import { type BreakdownFilterStore } from './store/breakdownFilterStore'
import { BreakdownFilterStoreProvider } from './context/breakdownFilterContext'
import { BreakdownFilterDropdown } from './BreakdownFilterDropdown'

export const BreakdownFilter = observer(
  ({ store, parentWidth }: { store: BreakdownFilterStore; parentWidth?: number }) => {
    return (
      <BreakdownFilterStoreProvider store={store}>
        <BreakdownFilterDropdown parentWidth={parentWidth} />
      </BreakdownFilterStoreProvider>
    )
  }
)
